export default __webpack_public_path__ + "static/media/Rerebrace of the Death Master (nm).7c420813.jpg";